import { useEffect, useMemo, useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import Filter from "./FilterCancellation";
// import AddCancellation from "./AddCancellation";
import Delete from "./Delete";
import {
  downloadCSV,
  fetchAppointmentCancellationDetail,
} from "services/appointmentCancellations";
import { FormButton } from "components/Common/Buttons";
import Modal from "components/Common/Modal";
import { COLUMNS_DATA, DETAIL_COLUMNS, FILTER_DEFINATIONS } from "./config";
import Table from "components/Common/Table/index";
import usePagination from "hooks/usePagination";
import useFilterHook from "hooks/useFilter";
import { DEFAULT_TOTAL_RECORDS, MODALS, STALE_TIME } from "utils/constants";
import useDownloadCSV from "hooks/useDownloadCSV";
import Loader from "components/Common/loader";
import { fetchAppointmentCancellations } from "services/appointmentCancellations";

const AppointmentCancellations = () => {
  const [isAddCancellationOpen, setIsAddCancellationOpen] = useState(false);
  const [rowDataForEdit, setRowDataForEdit] = useState(null);
  const [isDelete, setIsDelete] = useState(-1);

  const [appId, setAppId] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  const [isSuperFranchise] = useState(() =>
    Number(localStorage.getItem("is_super_franchise")),
  );
  const [isFranchiseEmployee] = useState(() =>
    Number(localStorage.getItem("is_franchise_employee")),
  );
  const [isSubFranchise] = useState(() =>
    Number(localStorage.getItem("sub_franchise")),
  );

  const {
    currentPage,
    itemPerPage,
    disablePrev,
    disableNext,
    disableFirst,
    disableLast,
    totalPages,
    updateCurrentPage,
    updateTotalRecords,
  } = usePagination();

  const DownloadButton = useDownloadCSV(
    downloadCSV,
    "appointment_cancellations.csv",
  );

  const { filters, updateFilter, updateMultipleFilters } = useFilterHook(
    FILTER_DEFINATIONS,
    updateCurrentPage,
  );

  const editCancellation = useCallback((row) => {
    setRowDataForEdit(row);
    setIsAddCancellationOpen(true);
  }, []);

  const deleteRow = useCallback((row) => {
    setIsDelete(row.cancellation_id);
  }, []);

  const {
    data: cancellationData,
    isLoading,
    refetch: refetchCancellations,
  } = useQuery(
    ["fetch-appointment-cancellations", currentPage, filters],
    () => fetchAppointmentCancellations(currentPage, filters),
    {
      keepPreviousData: false,
      staleTime: STALE_TIME,
      onSuccess: (res) => {
        updateTotalRecords(res?.data?.additional_data?.total_count);
      },
      select: (res) => {
        const response = res?.data?.cancellation_data;
        if (response && response.length) {
          res.data.cancellation_data = response.map((x, index) => ({
            ...x,
            _index: (currentPage - 1) * DEFAULT_TOTAL_RECORDS + index + 1,
          }));
        }
        return res;
      },
      onError: (res) => {
        console.error("Error fetching appointment cancellations:", res);
      },
    },
  );

  const { data: cancellationDetail, isLoading: isDetailLoading } = useQuery(
    ["fetch-cancellation-detail", appId],
    () =>
      fetchAppointmentCancellationDetail(currentPage, {
        ...filters,
        appointment_id: appId,
      }),
    {
      enabled: !!appId, // sirf tab fetch karo jab appId ho
      staleTime: STALE_TIME,
      onError: (res) => {
        console.error("Error fetching cancellation detail:", res);
      },
    },
  );
  // const getRowProps = useCallback(
  //   (row) => ({
  //     onClick: () => {
  //       setAppId(row.appointment_id);
  //       setIsDetailModalOpen(true);
  //     },
  //     style: { cursor: "pointer" },
  //   }),
  //   [],
  // );

  const edit1 = useCallback((row) => {
    setAppId(row.appointment_id);

    setTimeout(() => {
      setIsDetailModalOpen(true);
    }, 1000);
  }, []);

  const getRowProps = useCallback(
    (row) => ({
      onClick: () => {
        edit1(row);
      },
    }),
    [edit1],
  );

  const onCloseDetailModal = useCallback(() => {
    setIsDetailModalOpen(false);
    setAppId(null);
  }, []);

  const onClose = useCallback(
    (refetch = false) => {
      if (refetch) refetchCancellations();
      setIsAddCancellationOpen(false);
      setRowDataForEdit(null);
    },
    [refetchCancellations],
  );

  const onCloseDelete = useCallback(
    (refetch = false) => {
      if (refetch) refetchCancellations();
      setIsDelete(-1);
    },
    [refetchCancellations],
  );

  const columns = useMemo(() => {
    return COLUMNS_DATA({
      deleteRow,
      editCancellation,
      isSuperFranchise,
      isFranchiseEmployee,
      isSubFranchise,
      filters,
    });
  }, [
    deleteRow,
    editCancellation,
    isSuperFranchise,
    isFranchiseEmployee,
    isSubFranchise,
    filters.is_active,
  ]);

  const columnsDetail = useMemo(() => {
    return DETAIL_COLUMNS({
      deleteRow,
      editCancellation,
      isSuperFranchise,
      isFranchiseEmployee,
      isSubFranchise,
      filters,
    });
  }, [
    deleteRow,
    editCancellation,
    isSuperFranchise,
    isFranchiseEmployee,
    isSubFranchise,
    filters.is_active,
  ]);

  useEffect(() => {
    if (filters.text) {
      refetchCancellations();
    }
  }, [filters.text, refetchCancellations]);

  const loadNextPage = useCallback(() => {
    updateCurrentPage(currentPage + 1);
  }, [currentPage, updateCurrentPage]);

  const loadPreviousPage = useCallback(() => {
    updateCurrentPage(currentPage - 1);
  }, [currentPage, updateCurrentPage]);

  const loadFirstPage = useCallback(() => {
    if (currentPage !== 1) {
      updateCurrentPage(1);
    }
  }, [currentPage, updateCurrentPage]);

  const loadLastPage = useCallback(() => {
    if (currentPage !== totalPages) {
      updateCurrentPage(totalPages);
    }
  }, [currentPage, totalPages, updateCurrentPage]);

  if (isLoading) {
    return <Loader isLoading={isLoading} />;
  }

  console.log("cancellationDetail", cancellationDetail);

  return (
    <div className="container-fluid mb-3">
      <div className="box mb-4">
        <div className="boxHeader">
          <h1>Appointment Cancellations</h1>

          <DownloadButton />

          <Modal
            show={isDelete !== -1}
            onHide={() => onCloseDelete()}
            modalName={MODALS.DELETE_CANCELLATION_MODAL}
            title={"Are you sure you want to delete this cancellation?"}
            footer={<Delete onClose={onCloseDelete} item={isDelete} />}
          />
        </div>
        <div className="left boxHeader d-flex mb-1 align-items-center">
          <Filter
            updateFilter={updateFilter}
            filters={filters}
            updateMultipleFilters={updateMultipleFilters}
          />
        </div>

        <Modal
          show={isDetailModalOpen}
          onHide={onCloseDetailModal}
          title="Cancellation Detail"
          footer={
            <button className="btn btn-secondary" onClick={onCloseDetailModal}>
              Close
            </button>
          }
          body={
            <Table
              data={cancellationDetail?.data?.data || []}
              isLoading={isLoading}
              tableColumns={columnsDetail}
              currentPage={currentPage}
              totalPages={totalPages}
              itemPerPage={itemPerPage}
              disablePrev={disablePrev}
              disableNext={disableNext}
              disableFirst={disableFirst}
              disableLast={disableLast}
              loadFirstPage={loadFirstPage}
              loadLastPage={loadLastPage}
              totalRecords={5}
              loadNextPage={loadNextPage}
              loadPreviousPage={loadPreviousPage}
            />
          }
        ></Modal>

        <div className="boxBody">
          <Table
            getRowProps={getRowProps}
            data={cancellationData?.data?.data || []}
            isLoading={isLoading}
            tableColumns={columns}
            currentPage={currentPage}
            totalPages={totalPages}
            itemPerPage={itemPerPage}
            disablePrev={disablePrev}
            disableNext={disableNext}
            disableFirst={disableFirst}
            disableLast={disableLast}
            loadFirstPage={loadFirstPage}
            loadLastPage={loadLastPage}
            totalRecords={5}
            loadNextPage={loadNextPage}
            loadPreviousPage={loadPreviousPage}
          />
        </div>
      </div>
    </div>
  );
};

export default AppointmentCancellations;
